import React from "react";
import { connect } from "react-redux";
import { Translate } from "react-localize-redux";
import { withRouter } from "react-router-dom";
import ConfirmCodeForm from "../../forms/ConfirmCodeForm";
import { confirmResetCodeAction } from "../../../redux/actions/accountRecovery.actions";

const RecoverAccountByTextPage = ({ errors, confirmResetCodeAction }) => (
  <div
    id="page-container"
    className="row align-items-center justify-content-center"
  >
    <ConfirmCodeForm
      headerText="Confirm number"
      errors={errors}
      confirmCodeAction={confirmResetCodeAction}
    />
  </div>
);

const mapStateToProps = ({ accountRecovery }) => ({
  errors: accountRecovery.errors
});

export default withRouter(
  connect(
    mapStateToProps,
    { confirmResetCodeAction }
  )(RecoverAccountByTextPage)
);



// WEBPACK FOOTER //
// ./src/components/pages/RecoverAccountByTextPage/RecoverAccountByTextPage.jsx